import { render, staticRenderFns } from "./Liquidez.vue?vue&type=template&id=019b09e9&scoped=true&"
import script from "./Liquidez.vue?vue&type=script&lang=js&"
export * from "./Liquidez.vue?vue&type=script&lang=js&"
import style0 from "./Liquidez.vue?vue&type=style&index=0&id=019b09e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b09e9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
